import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CorreoContacto");

const otros = {
    EnviarCorreoContacto: async (datos: models.CorreoContactoDatos): Promise<boolean> => await controller('EnviarCorreoContacto', {}, datos ),
}

export const CorreoContacto = cacheResource({
    ...otros
}, {
    }, {
    })


// WEBPACK FOOTER //
// ./app/resources/items/correocontactocontroller.tsx